export const getRecurrenceTypeForTracking = (
  recurrenceType?: string
): 'none' | 'custom' | 'weekly' | 'specificDate' => {
  if (recurrenceType === 'SPECIFIC_DATE') return 'specificDate';
  if (recurrenceType === 'WEEKLY') return 'weekly';
  if (recurrenceType === 'CUSTOM') return 'custom';
  if (recurrenceType === 'SINGLE_OCCURRENCE') return 'none';
  return 'none';
};

export const getBookingCadenceForTracking = (
  bookingCadence?: string
): 'none' | 'everyHour' | 'topOfHour' | 'thirtyMinutes' => {
  if (bookingCadence === 'EVERY_HOUR') return 'everyHour';
  if (bookingCadence === 'TOP_OF_THE_HOUR') return 'topOfHour';
  if (bookingCadence === 'EVERY_HALF_HOUR') return 'thirtyMinutes';
  return 'none';
};

export const getPatientBookingForTracking = (patientBooking?: string): 'direct' | 'request' | 'none' => {
  if (patientBooking === 'REQUEST') return 'request';
  if (patientBooking === 'INTERNAL') return 'none';
  if (patientBooking === 'DIRECT') return 'direct';
  return 'none';
};
